export default __webpack_public_path__ + "styles/ChooseValuesPopup.1e8e5003664008943d45f86171f1a290.css";